<template>
    <div class="planAlokasiChart" ref="chartDiv" style="width: 100%; height: 400px;"></div>
</template>

<script>
    import { create } from '@amcharts/amcharts4/core';
    import am4themes_animated from '@amcharts/amcharts4/themes/animated';
    import { XYChart, CategoryAxis, ValueAxis, ColumnSeries, LineSeries , Legend } from '@amcharts/amcharts4/charts';
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";

    import moment from 'moment'
    export default {
    data () {
        return {
            chart : null,
            trendlineSeries : null
        }
    },
    name: 'ColumnBarChart',
    watch : {
        data : function () {
            this.getData()
        }
    },
    props : ['data'],
    methods : {
        getData () {
            console.log(this.data)

            // this.data.push({time : 'No Data', bulan : 1 , tahun : 2023, counterfeit_trend : 1 , total_counterfeit : 0 , total_genuine : 0})

            let length = this.chart.data.length;
            for(var i = 0 ; i < this.data.length ; i++) {
                this.data[i].time = new moment().month(this.data[i].bulan - 1).year(this.data[i].tahun).format('MMMM Y')
            }

            this.chart.addData(this.data && this.data.length > 0 ? this.data : [{time : 'No Data', counterfeit_trend : 1 , total_counterfeit : 0 , total_genuine : 0}], length);
            console.log(this.chart.data)
        },
    },
    mounted() {
        // Apply the animated theme for some basic chart animations
        am4core.useTheme(am4themes_animated);

        // Create the chart instance
        const chart = create(this.$refs.chartDiv, XYChart);

        // Create category axis
        const categoryAxis = chart.xAxes.push(new CategoryAxis());
        categoryAxis.dataFields.category = 'time';
        //   categoryAxis.title.text = 'Plants';

        // Create value axis
        const valueAxis = chart.yAxes.push(new ValueAxis());
        valueAxis.title.text = 'Scan Activity ( Bar Chart )';
        valueAxis.renderer.opposite = false;
        valueAxis.numberFormatter.numberFormat = "#.##";
        // chart.events.on("datavalidated", function() {
        //     // Assume values are below 1000 by default
        //     let isBelow1000 = true;
            
        //     // Loop through your data
        //     for (let dataPoint of chart.data) {
        //         if (dataPoint.value > 1000) { // Assuming "value" is the name of your data field
        //             isBelow1000 = false;
        //             break; // Exit loop once a value above 1000 is found
        //         }
        //     }
            
        //     if (isBelow1000) {
        //         valueAxis.min = 1000; // Set minimum to 1000 if all values are below 1000
        //     } else {
        //         valueAxis.min = undefined; // Reset to automatic behavior if any value exceeds 1000
        //     }
        // });

        // Create the second series
        const series2 = chart.series.push(new ColumnSeries());
        series2.dataFields.valueY = 'total_genuine';
        series2.dataFields.categoryX = 'time';
        series2.name = 'Genuine';
        series2.stacked = true; // Stack this series
        series2.columns.template.fill = '#BCEAD1'
        series2.yAxis = valueAxis;

        const series1 = chart.series.push(new ColumnSeries());
        series1.dataFields.valueY = 'total_counterfeit';
        series1.dataFields.categoryX = 'time';
        series1.name = 'No Of Counterfeit';
        series1.stacked = true; // Stack this series
        series1.columns.template.fill = '#F0AFAF'
        series1.yAxis = valueAxis;

        // Change the radius of the bars
        series1.columns.template.column.adapter.add("cornerRadiusTopLeft", (cornerRadius, target) => {
            return 5; // You can adjust this value to change the radius as desired
        });
        
        series1.columns.template.column.adapter.add("cornerRadiusTopRight", (cornerRadius, target) => {
            return 5; // You can adjust this value to change the radius as desired
        });
        
        series1.columns.template.column.adapter.add("cornerRadiusBottomLeft", (cornerRadius, target) => {
            return 5; // You can adjust this value to change the radius as desired
        });
        
        series1.columns.template.column.adapter.add("cornerRadiusBottomRight", (cornerRadius, target) => {
            return 5; // You can adjust this value to change the radius as desired
        });

        // Change the radius of the bars
        series2.columns.template.column.adapter.add("cornerRadiusTopLeft", (cornerRadius, target) => {
            return 5; // You can adjust this value to change the radius as desired
        });
        
        series2.columns.template.column.adapter.add("cornerRadiusTopRight", (cornerRadius, target) => {
            return 5; // You can adjust this value to change the radius as desired
        });
        
        series2.columns.template.column.adapter.add("cornerRadiusBottomLeft", (cornerRadius, target) => {
            return 5; // You can adjust this value to change the radius as desired
        });
        
        series2.columns.template.column.adapter.add("cornerRadiusBottomRight", (cornerRadius, target) => {
            return 5; // You can adjust this value to change the radius as desired
        });

        var valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
        // valueAxis2.inversed = true;  // Reverse the axis
        valueAxis2.numberFormatter = new am4core.NumberFormatter();
        valueAxis2.numberFormatter.numberFormat = "#.##'%'";
        valueAxis2.renderer.labels.template.adapter.add("text", function(text) {
            return text;
        });
        valueAxis2.renderer.opposite = true;

        // Create a trendline series
        const trendlineSeries = chart.series.push(new LineSeries());
        trendlineSeries.dataFields.valueY = 'counterfeit_trend'; // Replace 'trendValue' with your trendline data field
        trendlineSeries.dataFields.categoryX = 'time';
        trendlineSeries.name = '% Counterfeit Trend';
        trendlineSeries.stroke = am4core.color('#A342CE'); // Change the trendline color as needed
        trendlineSeries.yAxis = valueAxis2

        var bullet = trendlineSeries.bullets.push(new am4charts.CircleBullet());
        bullet.circle.radius = 4; // Set the bullet size
        bullet.circle.fill = am4core.color("#A342CE");

        chart.legend = new am4charts.Legend();
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.xAxis = categoryAxis;

        // Configure the trendline appearance
        trendlineSeries.tensionX = 1; // Adjust the tension to control the curve

        // Set the color of each bar based on the "color" property in the data
        // series1.columns.template.propertyFields.fill = 'color1';
        // series2.columns.template.propertyFields.fill = 'color2';

        // Remove the border color
        series1.columns.template.strokeOpacity = 0;
        series2.columns.template.strokeOpacity = 0;

        // Set the width of the columns
        series1.columns.template.width = am4core.percent(25); // Change this value to make columns wider or narrower
        series2.columns.template.width = am4core.percent(25); // Change this value to make columns wider or narrower

        series1.columns.template.tooltipText = 'No Of Counterfeit on {categoryX}: {valueY}[/] ({counterfeit_trend}%)';
        series2.columns.template.tooltipText = 'No Of Counterfeit on {categoryX}: {valueY}[/]';
        // trendlineSeries.tooltipText = 'Trend On {categoryX}: [bold]{valueY}[/] %';

        this.chart = chart
        this.getData()
    },
        beforeDestroy() {
            if (this.chart) {
            this.chart.dispose();
            }
        }
    };
</script>

<style>
    /* Add any custom styles here if needed */
</style>
